/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDialogMessage } from '../components/ami-dialog-message/ami-dialog-message.interface';

@Component({
  template: ''
})
export class SidebarComponent {
  @Output() close = new EventEmitter<any>();
  open = true;
  @Input() item: any;
  newItem: any;
  changeForm = false;
  readyToStock = false;
  fg: FormGroup;
  message: IDialogMessage;
  constructor(@Inject(String) private name: string) {}

  onClose() {
    this.close.emit();
  }
}
